import compileSymbols from '~/utils/compileSymbols';
var types = [
  'CLEAR',
  'CREATE',
  'BATCH_CREATE',
  'REMOVE_EMPTY_NAMES_AND_NUMBERS',
  'REMOVE_INVALID_NAMES_AND_NUMBERS',
  'UPDATE',
  'DELETE',
  'ADD_NAMES',
  'ADD_NUMBERS',
  'ADD_NAMES_AND_NUMBERS'
];
export default compileSymbols(types, 'namesAndNumbers');
